// extracted by mini-css-extract-plugin
export default {"modal":"CopyCustomisationModal-modal-Tp6","container":"CopyCustomisationModal-container-OM4"};